import { useEffect } from 'react';

export function useScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component mounts or updates
  }, []);
}